/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from "react";
import { useTimeStore } from "../../stores/time";
import { Checkbox } from "../ui/inputs/Checkbox";
import { Select } from "../ui/inputs/Select";
import { getCustomerFiles, getMissions } from "../../api/customerFile";
import { showToastError, showToastSuccess } from "../../services/toast";
import SelectWithInput from "react-select";
import { hours, minutes } from "../../data/hourData";
import { TextArea } from "../ui/inputs/TextArea";
import { getTime, updateTime } from "../../api/times";
import { postTime } from "../../api/users";
import { getLabelsAdministrative } from "../../api/timeslabels";
import { SelectText } from "../ui/inputs/SelectText";
import { formatDateToFrench } from "../../services/date";
import { ModalButton, ModalShell } from "../ui/modals/ModalShell";

const Time = ({ closeModal, day }: any) => {
  const {
    formData,
    setFormData,
    libelles,
    setLibelles,
    clients,
    setClients,
    missions,
    setMissions,
    idUserSelected,
    resetTime,
    update,
    setUpdate,
    idTimeSelected,
    setIdTimeSelected,
    tab,
  } = useTimeStore();

  // Transformer les heures et les minutes en objets compatibles avec react-select
  const hourOptions = hours.map((hour) => ({
    value: hour,
    label: hour,
  }));
  const minutesOptions = minutes.map((minute) => ({
    value: minute,
    label: minute,
  }));

  // Récupere les données d'un temps sélectionné
  useEffect(() => {
    if (idTimeSelected !== 0) {
      getTime(idTimeSelected)
        .then((response) => {
          const hour = response.data.length.split(":")[0];
          const minutes = response.data.length.split(":")[1];

          setFormData({
            ...response.data,
            hour: hour,
            minutes: minutes,
          });
        })
        .catch(() => {
          showToastError("Une erreur est survenue");
        });
    }
  }, [idTimeSelected]);

  // Rajoute la date sélectionnée dans le formulaire
  useEffect(() => {
    setFormData({
      date: day,
      chargeable: true, // Par défaut, le temps est facturable
    });
  }, []);

  // Récupère les libellés si c'est un temps administrative sinon les clients
  useEffect(() => {
    if (formData.administrative === true) {
      getLabelsAdministrative()
        .then((response) => {
          const formattedData = response.data.map((item: any) => ({
            value: item.id,
            label: item.name,
          }));
          setLibelles(formattedData);
        })
        .catch((err) => {
          showToastError(err.response.data.message)
        });
    } else {
      getCustomerFiles()
        .then((response) => {
          const formattedData = response.data.map((item: any) => ({
            value: item.id,
            label: item?.name,
          }));
          const sortedData = formattedData.sort((a: any, b: any) => a.label.localeCompare(b.label));
          setClients(sortedData);
        })
        .catch((err) => {
          showToastError(err.response.data.message)
        });
    }
  }, [formData.administrative]);

  // Récupère les missions en fonction du client sélectionné
  useEffect(() => {
    if (formData.idCustomerFile) {
      getMissions(formData.idCustomerFile)
        .then((res) => {
          // Filtre les missions fermées
          const missionsWithoutClosed = res.data.filter(
            (item: any) => item.closed === false
          );
          const formattedData = missionsWithoutClosed.map((item: any) => {
            if (item.startDate.split("/")[2] === item.endDate.split("/")[2] || item.endDate.split("/")[2] === null || item.endDate.split("/")[2] === undefined) {
              return {
                ...item, // Garder toutes les propriétés originales
                value: item.id,
                label: item.department + " " + item.startDate.split("/")[2],
              };
            } else {
              const date =
                item.startDate.split("/")[2] +
                " - " +
                item.endDate.split("/")[2];
              return {
                ...item, // Garder toutes les propriétés originales
                value: item.id,
                label: item.department + " " + date,
              };
            }
          });

          // Si toutes les missions sont fermées ou qu'il n'y a pas de mission
          if (formattedData.length === 0) {
            showToastError("Il n'y a pas de mission pour ce client");
          } else if (formattedData.length === 1) {
            // Si il n'y a qu'une mission, on la sélectionne automatiquement
            setFormData({
              ...formData,
              idMission: formattedData[0].value,
            });
          }
          setMissions(formattedData);
        })
        .catch(() => {
          showToastError("Une erreur est survenue");
        });
    }
  }, [formData.idCustomerFile]);

  // Gestion des changements de formulaire
  const handleChangeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked,
    });
  };

  const handleSelectTextChange = (selectedOption: any) => {
    if (selectedOption) {
      setFormData({ ...formData, idCustomerFile: selectedOption.value });
    } else {
      setFormData({ ...formData, idCustomerFile: null });
    }
  };
  
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: parseInt(e.target.value) });
  };

  // Création / modification d'un temps
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // NE CREER PAS DE TEMPS SI IL N'Y A PAS DE MISSION
    if (
      formData.idMission === 0 ||
      (!formData.idMission && !formData.administrative)
    ) {
      showToastError("Veuillez sélectionner une mission");
      return;
    } else if (formData.administrative && !formData.idTimesLabel) {
      return showToastError("Veuillez sélectionner un libellé");
    }

    // Si c'est un temps administratif, on met le chargeable à false
    if(formData.administrative === true) {
      formData.chargeable = false;
      formData.idMission = null;
      formData.idCustomerFile = null;
    }

    const hasHour = "hour" in formData;
    const hasMinutes = "minutes" in formData;

    if (
      (!hasHour && !hasMinutes) || // aucune des deux clés
      (hasHour && hasMinutes && formData.hour === 0 && formData.minutes === 0)
    ) {
      return showToastError("Veuillez sélectionner une durée");
    }

    // Si minutes existe mais pas hour, on met hour à "00"
    if (!hasHour && hasMinutes) {
      formData.hour = "00";
    }

    const { idCustomerFile, hour, minutes, ...newFormData } = formData;

    const data = {
      ...newFormData,
      length: `${formData.hour}:${formData.minutes || "00"}`,
      date: new Date(formData.date),
    };

    if (idTimeSelected === 0) {
      postTime(Number(idUserSelected), data)
        .then(() => {
          showToastSuccess("Le temps a bien été ajouté");
          resetTime();
          setUpdate(!update);
          closeModal();
        })
        .catch((err) => {
          if(err.response.data.message === "Public holiday") {
            showToastError("Le temps ne peut pas être ajouté car c'est un jour férié");
          } else {
            showToastError("Une erreur est survenue");
          }
        });
    } else {
      const data = {
        ...formData,
        length: `${formData.hour}:${formData.minutes}`,
      };
      updateTime(idTimeSelected, data)
        .then(() => {
          showToastSuccess("Le temps a bien été modifié");
          if (tab === "Time") {
            resetTime();
          } else {
            setIdTimeSelected(0);
          }
          setUpdate(!update);
          closeModal();
        })
        .catch(() => {
          showToastError("Une erreur est survenue");
        });
    }
  };

  const handleClose = () => {
    if (tab === "Time") {
      resetTime();
    } else {
      setIdTimeSelected(0);
    }
    setFormData({});
    closeModal();
  };

  const selectedMission = missions.find(
    (mission: any) => mission.id === Number(formData.idMission)
  );

  const selectMenuProps = {
    menuPortalTarget: typeof document !== "undefined" ? document.body : null,
    menuPosition: "fixed" as const,
    menuPlacement: "auto" as const,
    styles: {
      menuPortal: (base: object) => ({ ...base, zIndex: 9999 }),
    },
  };

  return (
    <ModalShell
      title={
        idTimeSelected !== 0
          ? `Modifier le temps du ${formatDateToFrench(formData.date)}`
          : `Ajouter un temps pour le ${formatDateToFrench(day)}`
      }
      size="xl"
      onClose={handleClose}
      footer={
        <>
          <ModalButton variant="secondary" onClick={handleClose}>
            Annuler
          </ModalButton>
          <ModalButton variant="primary" type="submit" form="time-form">
            {idTimeSelected !== 0 ? "Modifier" : "Créer"}
          </ModalButton>
        </>
      }
    >
      <form
        id="time-form"
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 font-Nunito"
      >
        <div className="flex flex-wrap items-center gap-4">
          <Checkbox
            label="Administratif"
            name="administrative"
            onChange={() => {
              setFormData({
                ...formData,
                administrative: !formData.administrative,
              }); // Reset form
              handleChangeCheckbox;
            }}
            checked={formData.administrative}
            value={formData.administrative}
          />
          <Checkbox
            label="Télétravail"
            name="remote"
            onChange={handleChangeCheckbox}
            checked={formData.remote}
            value={formData.remote}
          />
        </div>

        {formData.administrative ? (
          <div className="rounded-xl bg-slate-50 p-4 ring-1 ring-slate-100 ring-inset">
            <Select
              label="Libellé"
              name="idTimesLabel"
              onChange={handleSelectChange}
              value={formData.idTimesLabel}
              fetchOptions={libelles}
              className="w-full cursor-pointer sm:max-w-sm"
            />
          </div>
        ) : (
          <div className="flex flex-col gap-3 rounded-xl bg-slate-50 p-4 ring-1 ring-slate-100 ring-inset">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
              <SelectText
                label="Dossier"
                name="idCustomerFile"
                onChange={handleSelectTextChange}
                value={formData.idCustomerFile}
                fetchOptions={clients}
                className="cursor-pointer"
              />
              <Select
                label="Mission"
                name="idMission"
                onChange={handleSelectChange}
                value={formData.idMission}
                fetchOptions={missions}
                className="w-full cursor-pointer"
              />
              {formData.idMission && selectedMission?.plannedTime !== 0 && (
                <div className="flex flex-col justify-center gap-0.5">
                  <p className="text-sm text-slate-600">
                    Budget total :{" "}
                    <span className="font-bold text-slate-800 tabular-nums">
                      {selectedMission?.plannedTime} h
                    </span>
                  </p>
                  <p className="text-sm text-slate-600">
                    Budget restant :{" "}
                    <span className="font-bold text-slate-800 tabular-nums">
                      {selectedMission?.availableTime < 0
                        ? "⚠️ " + selectedMission?.availableTime
                        : selectedMission?.availableTime}{" "}
                      h
                    </span>
                  </p>
                </div>
              )}
            </div>

            {selectedMission?.availableTime < 0 &&
              selectedMission?.plannedTime !== 0 && (
                <p className="rounded-lg bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-700 ring-1 ring-red-100 ring-inset">
                  Le budget temps restant est négatif
                </p>
              )}

            <div className="flex flex-wrap items-center gap-4">
              <Checkbox
                label="XS"
                name="XS"
                onChange={handleChangeCheckbox}
                checked={formData.XS}
                value={formData.XS}
              />
              <Checkbox
                label="Facturable"
                name="chargeable"
                onChange={handleChangeCheckbox}
                checked={formData.chargeable}
                value={formData.chargeable}
              />
            </div>
          </div>
        )}

        <div className="grid grid-cols-2 gap-3 rounded-xl bg-slate-50 p-4 ring-1 ring-slate-100 ring-inset sm:max-w-sm">
          <div>
            <p className="mb-1 text-[11px] font-bold tracking-wider text-slate-400 uppercase">
              Heures
            </p>
            <SelectWithInput
              className="basic-single w-full"
              name="hour"
              options={hourOptions}
              {...selectMenuProps}
              value={hourOptions.find(
                (option) => option.value === formData.hour
              )}
              onChange={(e: any) => {
                setFormData({
                  ...formData,
                  hour: e.value,
                });
              }}
            />
          </div>
          <div>
            <p className="mb-1 text-[11px] font-bold tracking-wider text-slate-400 uppercase">
              Minutes
            </p>
            <SelectWithInput
              className="basic-single w-full"
              name="minutes"
              {...selectMenuProps}
              value={minutesOptions.find(
                (option) => option.value === formData.minutes
              )}
              options={minutesOptions}
              onChange={(e: any) => {
                setFormData({
                  ...formData,
                  minutes: e.value,
                });
              }}
            />
          </div>
        </div>

        <TextArea
          label="Commentaire"
          name="comment"
          value={formData.comment}
          onChange={(e) => {
            setFormData({
              ...formData,
              comment: e.target.value,
            });
          }}
        />
      </form>
    </ModalShell>
  );
};

export default Time;
